var _style, _path, _path2, _ellipse, _ellipse2, _path3, _path4, _defs, _defs2, _defs3, _path5, _defs4, _path6, _defs5, _path7, _defs6, _path8, _defs7, _defs8, _path9, _defs9, _defs10, _path10, _defs11, _path11, _defs12, _path12, _ellipse3, _ellipse4, _path13, _path14, _defs13, _defs14, _defs15, _path15, _defs16, _path16, _defs17, _path17, _defs18, _path18, _defs19, _defs20, _path19, _defs21, _defs22, _path20, _defs23, _path21, _defs24, _path22, _path23;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHangingOwl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "426px",
    height: "504px",
    viewBox: "0 0 426 504",
    style: {
      enableBackground: "new 0 0 426 504"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st2{clip-path:url(#SVGID_2_);}\r\n\t.st3{clip-path:url(#SVGID_4_);}\r\n\t.st4{clip-path:url(#SVGID_6_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st5{clip-path:url(#SVGID_8_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st6{clip-path:url(#SVGID_10_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st7{clip-path:url(#SVGID_12_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st8{opacity:0.9686;clip-path:url(#SVGID_14_);enable-background:new    ;}\r\n\t.st9{clip-path:url(#SVGID_16_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st10{opacity:0.9686;clip-path:url(#SVGID_18_);enable-background:new    ;}\r\n\t.st11{clip-path:url(#SVGID_20_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st12{clip-path:url(#SVGID_22_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st13{clip-path:url(#SVGID_24_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st14{clip-path:url(#SVGID_26_);}\r\n\t.st15{clip-path:url(#SVGID_28_);}\r\n\t.st16{clip-path:url(#SVGID_30_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st17{clip-path:url(#SVGID_32_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st18{clip-path:url(#SVGID_34_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st19{clip-path:url(#SVGID_36_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st20{opacity:0.9686;clip-path:url(#SVGID_38_);enable-background:new    ;}\r\n\t.st21{clip-path:url(#SVGID_40_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st22{opacity:0.9686;clip-path:url(#SVGID_42_);enable-background:new    ;}\r\n\t.st23{clip-path:url(#SVGID_44_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st24{clip-path:url(#SVGID_46_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st25{clip-path:url(#SVGID_48_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st26{fill:none;stroke:#000000;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st27{display:none;fill:#FFFFFF;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st28{display:none;fill:#EFEEEE;}\r\n\t.st29{display:none;opacity:0.2784;fill:url(#SVGID_49_);enable-background:new    ;}\r\n\t.st30{display:none;opacity:0.3216;fill:url(#SVGID_50_);enable-background:new    ;}\r\n\t.st31{display:none;opacity:0.3294;fill:url(#SVGID_51_);enable-background:new    ;}\r\n\t.st32{display:none;opacity:0.251;fill:url(#SVGID_52_);enable-background:new    ;}\r\n\t.st33{display:none;opacity:0.349;fill:url(#SVGID_53_);enable-background:new    ;}\r\n\t.st34{display:none;}\r\n\t.st35{display:none;fill:none;stroke:#000000;stroke-width:15;stroke-miterlimit:10;}\r\n\t.st36{display:none;stroke:#000000;stroke-width:3.5;stroke-miterlimit:10;}\r\n\t.st37{display:none;fill:none;stroke:#000000;stroke-width:3.5;stroke-miterlimit:10;}\r\n\t.st38{display:none;fill:#FFFFFF;}\r\n\t.st39{display:none;fill:#EAC457;stroke:#EAC457;stroke-miterlimit:10;}\r\n\t.st40{display:none;fill:#EAC457;}\r\n\t.st41{display:none;fill:#EAC457;stroke:#000000;stroke-width:7;stroke-miterlimit:10;}\r\n\t.st42{opacity:0.9686;fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;enable-background:new    ;}\r\n\t.st43{fill:none;}\r\n\t.st44{stroke:#000000;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st45{clip-path:url(#SVGID_55_);}\r\n\t.st46{clip-path:url(#SVGID_57_);}\r\n\t.st47{clip-path:url(#SVGID_59_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st48{clip-path:url(#SVGID_61_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st49{clip-path:url(#SVGID_63_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st50{clip-path:url(#SVGID_65_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st51{opacity:0.9686;clip-path:url(#SVGID_67_);enable-background:new    ;}\r\n\t.st52{clip-path:url(#SVGID_69_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st53{opacity:0.9686;clip-path:url(#SVGID_71_);enable-background:new    ;}\r\n\t.st54{clip-path:url(#SVGID_73_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st55{clip-path:url(#SVGID_75_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st56{clip-path:url(#SVGID_77_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st57{clip-path:url(#SVGID_79_);}\r\n\t.st58{clip-path:url(#SVGID_81_);}\r\n\t.st59{clip-path:url(#SVGID_83_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st60{clip-path:url(#SVGID_85_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st61{clip-path:url(#SVGID_87_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st62{clip-path:url(#SVGID_89_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st63{opacity:0.9686;clip-path:url(#SVGID_91_);enable-background:new    ;}\r\n\t.st64{clip-path:url(#SVGID_93_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st65{opacity:0.9686;clip-path:url(#SVGID_95_);enable-background:new    ;}\r\n\t.st66{clip-path:url(#SVGID_97_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st67{clip-path:url(#SVGID_99_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st68{clip-path:url(#SVGID_101_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st69{clip-path:url(#SVGID_103_);}\r\n\t.st70{clip-path:url(#SVGID_105_);}\r\n\t.st71{clip-path:url(#SVGID_107_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st72{clip-path:url(#SVGID_109_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st73{clip-path:url(#SVGID_111_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st74{clip-path:url(#SVGID_113_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st75{opacity:0.9686;clip-path:url(#SVGID_115_);enable-background:new    ;}\r\n\t.st76{clip-path:url(#SVGID_117_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st77{opacity:0.9686;clip-path:url(#SVGID_119_);enable-background:new    ;}\r\n\t.st78{clip-path:url(#SVGID_121_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st79{clip-path:url(#SVGID_123_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st80{clip-path:url(#SVGID_125_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st81{clip-path:url(#SVGID_127_);}\r\n\t.st82{clip-path:url(#SVGID_129_);}\r\n\t.st83{clip-path:url(#SVGID_131_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st84{clip-path:url(#SVGID_133_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st85{clip-path:url(#SVGID_135_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st86{clip-path:url(#SVGID_137_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st87{opacity:0.9686;clip-path:url(#SVGID_139_);enable-background:new    ;}\r\n\t.st88{clip-path:url(#SVGID_141_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st89{opacity:0.9686;clip-path:url(#SVGID_143_);enable-background:new    ;}\r\n\t.st90{clip-path:url(#SVGID_145_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st91{clip-path:url(#SVGID_147_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st92{clip-path:url(#SVGID_149_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st93{clip-path:url(#SVGID_151_);}\r\n\t.st94{clip-path:url(#SVGID_153_);}\r\n\t.st95{clip-path:url(#SVGID_155_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st96{clip-path:url(#SVGID_157_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st97{clip-path:url(#SVGID_159_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st98{clip-path:url(#SVGID_161_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st99{opacity:0.9686;clip-path:url(#SVGID_163_);enable-background:new    ;}\r\n\t.st100{clip-path:url(#SVGID_165_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st101{opacity:0.9686;clip-path:url(#SVGID_167_);enable-background:new    ;}\r\n\t.st102{clip-path:url(#SVGID_169_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st103{clip-path:url(#SVGID_171_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st104{clip-path:url(#SVGID_173_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st105{clip-path:url(#SVGID_175_);}\r\n\t.st106{clip-path:url(#SVGID_177_);}\r\n\t.st107{clip-path:url(#SVGID_179_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st108{clip-path:url(#SVGID_181_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st109{clip-path:url(#SVGID_183_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st110{clip-path:url(#SVGID_185_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st111{opacity:0.9686;clip-path:url(#SVGID_187_);enable-background:new    ;}\r\n\t.st112{clip-path:url(#SVGID_189_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st113{opacity:0.9686;clip-path:url(#SVGID_191_);enable-background:new    ;}\r\n\t.st114{clip-path:url(#SVGID_193_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st115{clip-path:url(#SVGID_195_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st116{clip-path:url(#SVGID_197_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st117{clip-path:url(#SVGID_199_);}\r\n\t.st118{clip-path:url(#SVGID_201_);}\r\n\t.st119{clip-path:url(#SVGID_203_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st120{clip-path:url(#SVGID_205_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st121{clip-path:url(#SVGID_207_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st122{clip-path:url(#SVGID_209_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st123{opacity:0.9686;clip-path:url(#SVGID_211_);enable-background:new    ;}\r\n\t.st124{clip-path:url(#SVGID_213_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st125{opacity:0.9686;clip-path:url(#SVGID_215_);enable-background:new    ;}\r\n\t.st126{clip-path:url(#SVGID_217_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st127{clip-path:url(#SVGID_219_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st128{clip-path:url(#SVGID_221_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st129{stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st130{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.83,219.3c-2.26,2.85-2.64,7.92-4.53,11.45c-10.57-4.1-30.41-8.4-41.51-6.71 c-10.06,1.54-17.48,10.8-23.27,19.17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M306.03,298.59c17.76-0.47,35.94-3.04,53.8-7.58c2.7-0.69,4.93-3.07,4.86-5.2c-0.07-2.13-2.43-3.71-5.14-3.45 c-12.63,1.23-25.25,2.45-37.88,3.68c12.21-1.5,24.43-3,36.64-4.5c3.02-0.37,5.45-3.31,5.14-5.63c-0.31-2.32-2.73-3.89-5.52-4.39 c-2.79-0.5-5.9-0.1-8.93,0.4c-10.97,1.82-21.94,3.65-32.9,5.47c12.22-1.95,24.45-3.91,36.67-5.86c2.66-0.43,5.07-2.7,5.07-4.8 c0-2.09-2.4-3.63-5.06-3.23c-13.41,2-26.83,4-40.24,6c1.12-3.63,2.24-7.36,1.59-10.79c-0.65-3.43-3.52-6.5-7.91-6.7 c-4.39-0.2-9.72,3.55-9.07,6.98c0.84,4.45,1.68,8.9,2.18,13.53c0.34,1.82,0.25,3.78-2.09,4.58"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2377 -0.9713 0.9713 0.2377 -52.602 169.5447)",
    className: "st1",
    cx: 81.71,
    cy: 118.28,
    rx: 44.99,
    ry: 42.46
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2377 -0.9713 0.9713 0.2377 0.332 286.3597)",
    className: "st1",
    cx: 182.6,
    cy: 142.97,
    rx: 44.99,
    ry: 42.46
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.5,130.25c1.28-3.77,6.28-6.06,10.87-5c4.58,1.09,8.06,5.37,7.54,9.32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.05,187.46c-18.15-11.29-41.97-17.18-65.36-17.07c0.73,16.85,11.58,31.61,25.73,35.07 s30.59-4.62,39.02-19.23"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_174_",
    x: 25.62,
    y: 25.18,
    transform: "matrix(0.2377 -0.9713 0.9713 0.2377 -22.3802 230.4342)",
    width: 220,
    height: 208.59
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_174_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_176_",
    x: 25.62,
    y: 25.18,
    transform: "matrix(0.2377 -0.9713 0.9713 0.2377 -22.3802 230.4342)",
    width: 220,
    height: 208.59
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_176_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_178_",
    x: 25.62,
    y: 25.18,
    transform: "matrix(0.2377 -0.9713 0.9713 0.2377 -22.3802 230.4342)",
    width: 220,
    height: 208.59
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_178_",
    style: {
      overflow: "visible"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M165.62,218.4c-13.39,4.56-36.74,4.98-56.39,0.17"
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_180_",
    x: 25.62,
    y: 25.18,
    transform: "matrix(0.2377 -0.9713 0.9713 0.2377 -22.3802 230.4342)",
    width: 220,
    height: 208.59
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_180_",
    style: {
      overflow: "visible"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M171.08,216.21c-1.22,0.63-5.54,2.22-5.54,2.22L171.08,216.21z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_182_",
    x: 25.62,
    y: 25.18,
    transform: "matrix(0.2377 -0.9713 0.9713 0.2377 -22.3802 230.4342)",
    width: 220,
    height: 208.59
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_182_",
    style: {
      overflow: "visible"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.74,108.36c19.45,19.51,14.23,37.58,11.36,49.31c-7.24,29.59-34.8,49.52-52.07,58.57"
  }))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_184_",
    x: 25.62,
    y: 25.18,
    transform: "matrix(0.2377 -0.9713 0.9713 0.2377 -22.3802 230.4342)",
    width: 220,
    height: 208.59
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_184_",
    style: {
      overflow: "visible"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M109.45,218.65c-50.68-12.4-86.34-61.17-71.21-106.07c4.24-12.6,8.16-30.57,35.32-39.06"
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_186_",
    x: 25.62,
    y: 25.18,
    transform: "matrix(0.2377 -0.9713 0.9713 0.2377 -22.3802 230.4342)",
    width: 220,
    height: 208.59
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_186_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_188_",
    x: 60,
    y: 27.57,
    transform: "matrix(0.2377 -0.9713 0.9713 0.2377 18.2244 122.7237)",
    width: 54.59,
    height: 44.36
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_188_",
    style: {
      overflow: "visible"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M109.4,49.35c-6.26-9.73-13.44-18.19-22.71-24.93c-3.21-2.47-7.09-4.53-10.83-2.65 c-1.92,1.21-4,2.93-4.51,5.02c-3.62,12.51-4.65,22.89-2.22,35.2c1.16,4.19,2.28,10.77,5.01,11.44"
  })))))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_190_",
    x: 25.62,
    y: 25.18,
    transform: "matrix(0.2377 -0.9713 0.9713 0.2377 -22.3802 230.4342)",
    width: 220,
    height: 208.59
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_190_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_192_",
    x: 185.71,
    y: 51.47,
    transform: "matrix(0.2377 -0.9713 0.9713 0.2377 86.1704 269.8743)",
    width: 58.62,
    height: 57.15
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_192_",
    style: {
      overflow: "visible"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M210.63,108.09c7.68-2,17.97-3.92,21.53-11.73c-4.65,0-7.62-0.63-12.26-0.81 c8.44-2.92,16.33-7.87,22.03-14.95c-3.89,0.55-7.71,1.54-11.61,2.12c4.9-7.09,9.28-16.05,5.92-24.68 c-1.92-3.26-5.81-3.1-9.13-2.81c-13.91,3.3-26.52,10.24-38.86,17.26"
  })))))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_194_",
    x: 25.62,
    y: 25.18,
    transform: "matrix(0.2377 -0.9713 0.9713 0.2377 -22.3802 230.4342)",
    width: 220,
    height: 208.59
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_194_",
    style: {
      overflow: "visible"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M193.54,69.48c-1.76,0.68-2.93,2.77-4.79,3.03c-0.79,0.11-1.59-0.15-2.32-0.45 c-6.88-2.7-12.11-8.43-17.43-13.61c-5.33-5.18-11.52-10.21-18.62-10.08c7.95,3.78,14.15,11.06,16.15,19.72 c-6.59-7.17-15.4-12-24.67-14.75c-9.27-2.75-17.52-2.61-27.23-2.37c-2.11,0.05-4.7-0.13-5.55-2.08"
  }))), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_196_",
    x: 25.62,
    y: 25.18,
    transform: "matrix(0.2377 -0.9713 0.9713 0.2377 -22.3802 230.4342)",
    width: 220,
    height: 208.59
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_196_",
    style: {
      overflow: "visible"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M227.3,67.74c6.78-1.23-4.21,0.38-7.22,3.04c-3.54,3.1-15.38,11.35-17.25,15.73 c-0.54,1.22-1.03,2.51-1.98,3.48c-2.01,2.06-5.28,1.86-8.05,1.34c-10.08-1.96-19.49-6.54-29.51-8.87 c-2.1-0.48-4.34-0.88-6.36-0.11c-3.32,1.23-5.48,5.24-9.01,5.4c-3.86,0.17-6.05-4.18-8.15-7.43 c-3.33-5.14-8.51-8.84-14.17-11.01c-5.65-2.19-11.76-2.94-17.85-3.1c-3.41-0.08-6.9,0.02-10.16-1.04 c-0.74-0.24-1.51-0.58-1.98-1.21c-0.54-0.7-0.61-1.62-0.69-2.51c-0.67-7.52-2.5-14.91-5.43-21.81 c-0.73-1.71-4.33-6.11-5.95-7.01c-4.96-2.71,5.82,3.41,5.81,6.98"
  }))))))))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2377 -0.9713 0.9713 0.2377 -52.602 169.5447)",
    className: "st1",
    cx: 81.71,
    cy: 118.28,
    rx: 44.99,
    ry: 42.46
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2377 -0.9713 0.9713 0.2377 0.332 286.3597)",
    className: "st1",
    cx: 182.6,
    cy: 142.97,
    rx: 44.99,
    ry: 42.46
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.5,130.25c1.28-3.77,6.28-6.06,10.87-5c4.58,1.09,8.06,5.37,7.54,9.32"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.05,187.46c-18.15-11.29-41.97-17.18-65.36-17.07c0.73,16.85,11.58,31.61,25.73,35.07 s30.59-4.62,39.02-19.23"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_198_",
    x: 25.62,
    y: 25.18,
    transform: "matrix(0.2377 -0.9713 0.9713 0.2377 -22.3802 230.4342)",
    width: 220,
    height: 208.59
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_198_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_200_",
    x: 25.62,
    y: 25.18,
    transform: "matrix(0.2377 -0.9713 0.9713 0.2377 -22.3802 230.4342)",
    width: 220,
    height: 208.59
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_200_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_202_",
    x: 25.62,
    y: 25.18,
    transform: "matrix(0.2377 -0.9713 0.9713 0.2377 -22.3802 230.4342)",
    width: 220,
    height: 208.59
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_202_",
    style: {
      overflow: "visible"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M165.62,218.4c-13.39,4.56-36.74,4.98-56.39,0.17"
  }))), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_204_",
    x: 25.62,
    y: 25.18,
    transform: "matrix(0.2377 -0.9713 0.9713 0.2377 -22.3802 230.4342)",
    width: 220,
    height: 208.59
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_204_",
    style: {
      overflow: "visible"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M171.08,216.21c-1.22,0.63-5.54,2.22-5.54,2.22L171.08,216.21z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_206_",
    x: 25.62,
    y: 25.18,
    transform: "matrix(0.2377 -0.9713 0.9713 0.2377 -22.3802 230.4342)",
    width: 220,
    height: 208.59
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_206_",
    style: {
      overflow: "visible"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M211.74,108.36c19.45,19.51,14.23,37.58,11.36,49.31c-7.24,29.59-34.8,49.52-52.07,58.57"
  }))), /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_208_",
    x: 25.62,
    y: 25.18,
    transform: "matrix(0.2377 -0.9713 0.9713 0.2377 -22.3802 230.4342)",
    width: 220,
    height: 208.59
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_36_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_208_",
    style: {
      overflow: "visible"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M109.45,218.65c-50.68-12.4-86.34-61.17-71.21-106.07c4.24-12.6,8.16-30.57,35.32-39.06"
  }))), /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_210_",
    x: 25.62,
    y: 25.18,
    transform: "matrix(0.2377 -0.9713 0.9713 0.2377 -22.3802 230.4342)",
    width: 220,
    height: 208.59
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_38_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_210_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_212_",
    x: 60,
    y: 27.57,
    transform: "matrix(0.2377 -0.9713 0.9713 0.2377 18.2244 122.7237)",
    width: 54.59,
    height: 44.36
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_40_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_212_",
    style: {
      overflow: "visible"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M109.4,49.35c-6.26-9.73-13.44-18.19-22.71-24.93c-3.21-2.47-7.09-4.53-10.83-2.65 c-1.92,1.21-4,2.93-4.51,5.02c-3.62,12.51-4.65,22.89-2.22,35.2c1.16,4.19,2.28,10.77,5.01,11.44"
  })))))), /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_214_",
    x: 25.62,
    y: 25.18,
    transform: "matrix(0.2377 -0.9713 0.9713 0.2377 -22.3802 230.4342)",
    width: 220,
    height: 208.59
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_42_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_214_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st22"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_216_",
    x: 185.71,
    y: 51.47,
    transform: "matrix(0.2377 -0.9713 0.9713 0.2377 86.1704 269.8743)",
    width: 58.62,
    height: 57.15
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_44_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_216_",
    style: {
      overflow: "visible"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M210.63,108.09c7.68-2,17.97-3.92,21.53-11.73c-4.65,0-7.62-0.63-12.26-0.81 c8.44-2.92,16.33-7.87,22.03-14.95c-3.89,0.55-7.71,1.54-11.61,2.12c4.9-7.09,9.28-16.05,5.92-24.68 c-1.92-3.26-5.81-3.1-9.13-2.81c-13.91,3.3-26.52,10.24-38.86,17.26"
  })))))), /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_218_",
    x: 25.62,
    y: 25.18,
    transform: "matrix(0.2377 -0.9713 0.9713 0.2377 -22.3802 230.4342)",
    width: 220,
    height: 208.59
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_46_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_218_",
    style: {
      overflow: "visible"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M193.54,69.48c-1.76,0.68-2.93,2.77-4.79,3.03c-0.79,0.11-1.59-0.15-2.32-0.45 c-6.88-2.7-12.11-8.43-17.43-13.61c-5.33-5.18-11.52-10.21-18.62-10.08c7.95,3.78,14.15,11.06,16.15,19.72 c-6.59-7.17-15.4-12-24.67-14.75c-9.27-2.75-17.52-2.61-27.23-2.37c-2.11,0.05-4.7-0.13-5.55-2.08"
  }))), /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_220_",
    x: 25.62,
    y: 25.18,
    transform: "matrix(0.2377 -0.9713 0.9713 0.2377 -22.3802 230.4342)",
    width: 220,
    height: 208.59
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_48_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_220_",
    style: {
      overflow: "visible"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M227.3,67.74c6.78-1.23-4.21,0.38-7.22,3.04c-3.54,3.1-15.38,11.35-17.25,15.73 c-0.54,1.22-1.03,2.51-1.98,3.48c-2.01,2.06-5.28,1.86-8.05,1.34c-10.08-1.96-19.49-6.54-29.51-8.87 c-2.1-0.48-4.34-0.88-6.36-0.11c-3.32,1.23-5.48,5.24-9.01,5.4c-3.86,0.17-6.05-4.18-8.15-7.43 c-3.33-5.14-8.51-8.84-14.17-11.01c-5.65-2.19-11.76-2.94-17.85-3.1c-3.41-0.08-6.9,0.02-10.16-1.04 c-0.74-0.24-1.51-0.58-1.98-1.21c-0.54-0.7-0.61-1.62-0.69-2.51c-0.67-7.52-2.5-14.91-5.43-21.81 c-0.73-1.71-4.33-6.11-5.95-7.01c-4.96-2.71,5.82,3.41,5.81,6.98"
  }))))))))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M-1.67,239.37c21.36-21.29,46.56-14.56,62.11-10.6c1.37,0.35,0.62-1.72,0.97-2.68 c1.01-2.76,0.34-7.56,2.76-9.31c0.19-0.14,0.45-0.1,0.62,0.06c7.15,6.52,16.79,10.35,25.85,13.76c14.98,5.63,30.5,7.95,45.93,3.86 c0.41-0.11,0.76,0.28,0.61,0.67c-2.37,6.16-4.74,12.31-7.11,18.47c-0.1,0.26,0.03,0.57,0.29,0.67c9.94,3.89,22.4,2.16,32.06,6.95 c8.47,4.21,18.28,4.59,27.3,6.84c19.54,4.87,21.89,9.22,42.2,7.65s28.07-1.59,47.52-8.12c11.62-3.9,31.26,7.25,31.26,19.48 c0,17.4-22.88,23.63-33.07,28.79c-25.33,12.81-50.38,7.45-69.08,6.15c-22.62-1.57-22.94-4.43-58.95-13.77 c-0.24-0.06-0.49,0.06-0.6,0.28c-22.77,46.71-27.02,74.96-58.18,106.01c-13.52,13.47-53.31,38.3-67.32,45.33 C-20.53,481.98,6.32,385.4,0,311.77v152.88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangingOwl);
export default __webpack_public_path__ + "static/media/hangingOwl.3f473f7e4fa8d22ae99e98a01c0be9f7.svg";
export { ForwardRef as ReactComponent };